import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/home';
import MoThe from './pages/services/moThe';
import VayOnline from './pages/services/vayOnline';
import DangKyVay from './pages/services/dangKyVay';
import News from './pages/news';
import Contacts from './pages/contact';
import CardInfo from './pages/services/cardInfo';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dich-vu/vay-online" element={<VayOnline />} />
        <Route path="/dich-vu/vay-online/dang-ky-vay" element={<DangKyVay />} />
        <Route path="/dich-vu/mo-the" element={<MoThe />} />
        <Route path="/dich-vu/mo-the/card-info/:cardId" element={<CardInfo />} />
        <Route path="/dich-vu/mo-the/card-info" element={<CardInfo />} />
        <Route path="/tin-tuc" element={<News />} />
        <Route path="/lien-he" element={<Contacts />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;